<template>
  <a class="jobs-item-list-main" :href="`/jobs/${data.token}.html`" target="_blank">
    <div class="jd-content">
      <div class="jd">
        <div>
          <div class="jd-name text-overflow">{{data.job_post}}</div>
          <img v-if="data.job_nature === '校招'" class="jd-icon" src="https://files.wondercv.com/pc/campus-tag.png" alt="">
          <!-- <div class="jd-date">发布于：{{data.updated_at}}</div> -->
        </div>
        <div>
          <div class="jd-money">{{(data.annual_month_salary && data.annual_month_salary > 12) ? `${data.display_salary} · ${data.annual_month_salary}薪` : data.display_salary}}</div>
          <div class="jd-info text-overflow">

            <span v-if="data.city_names">{{(data.city_names && data.city_names[0]) || '全国'}}</span>

            <template v-if="data.job_nature === '全职'">
              <span>{{!data.display_experience || data.display_experience === '不限' ? '经验不限' : (data.display_experience === '1年以下' ? '1年以内' : data.display_experience)}}</span>
              <span>{{!data.degree_name || data.degree_name === '不限' ? '学历不限' : data.degree_name}}</span>
            </template>

            <template v-if="data.job_nature === '实习'">
              <span>{{!data.degree_name || data.degree_name === '不限' ? '学历不限' : data.degree_name}}</span>
              <span v-if="data.intern_frequency && data.intern_duration">{{ `${data.intern_frequency}天/周 ${data.intern_duration}` }}</span>
            </template>

            <template v-if="data.job_nature === '校招'">
              <span>{{ data.graduate_times | formatGraduationYear }}</span>
              <span>{{!data.degree_name || data.degree_name === '不限' ? '学历不限' : data.degree_name}}</span>
            </template>

          </div>
        </div>
      </div>
      <div class="company">
        <div class="company-name text-overflow">{{data.company_nick_name || data.company_name || '--'}}</div>
        <div class="company-info text-overflow">
          <!-- 互联网｜融资阶段｜50-100人 -->
          <span v-if="data.company_industry">{{data.company_industry}}</span>
          <span v-if="data.phase && data.phase!=='不需要融资'" class="l">{{data.phase}}</span>
          <span v-if="data.company_scale">{{data.company_scale}}</span>
        </div>
      </div>
      <div class="company-picture">
        <img :src="data.company_logo" alt="">
      </div>
    </div>
    <div class="tag" v-if="data.job_tags && data.job_tags.length">
      <div class="tag-content-main">
        <div class="tag-content" ref="itemListTag">
          <div class="tag-menu" v-for="(item, index) in data.job_tags" :key="index">{{item}}</div>
        </div>
      </div>
      <div class="tag-menu tag-more" v-if="isShowTag"><i class="iconfont iconmore-horizontal"></i></div>
    </div>
    <!-- <div class="jd-tag" v-if="data.origin_source === 'jd'">直投</div> -->
  </a>
</template>
<script>
export default {
  name: 'ItemList',
  props: {
    data: {}
  },
  data() {
    return {
      isShowTag: false,
    };
  },
  mounted() {
    this.setTag();
  },
  updated() {
    this.setTag();
  },
  filters: {
    formatGraduationYear (yearArr) {
      if (!yearArr || !yearArr.length) return ''
      let newArr = yearArr.map(item => {
        return String(item).substring(2)
      })
      return newArr.join('/') + '届'
    }
  },
  methods: {
    setTag() {
      this.$nextTick(() => {
        setTimeout(() => {
          let itemListTag = this.$refs.itemListTag;
          // console.log(itemListTag && itemListTag.offsetHeight);
          if (itemListTag && itemListTag.offsetHeight >= 50) {
            this.isShowTag = true;
          }
        }, 500);
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.jobs-item-list-main {
  display: block;
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  * {
    box-sizing: border-box;
  }
  &:hover {
    box-shadow:0px 2px 18px 0px rgba(236,236,236,1);
    .jd-content .jd .jd-name {
      color: #FF6644;
    }
  }
  padding: 0 32px;
  .jd-content {
    padding: 25px 0;
    display: felx;
    align-items: center;
    display: flex;
    align-items: center;
    .jd>div,
    .company>div {
      width: 100%;
      height: 16px;
      line-height: 16px;
      // background: red;
      display: flex;
      align-items: center;
      &:last-child {
        margin-top: 12px;
      }
    }
    .jd {
      width: 433px;
      .jd-name {
        height: 22px;
        line-height: 22px;
        font-size: 18px;
        font-weight: 500;
        color: #404040;
        margin-right: 6px;
      }
      .jd-icon {
        width: 32px;
      }
      .jd-date {
        flex: none;
        font-size: 12px;
        color: #9C9C9C;
      }
      .jd-money {
        font-size: 16px;
        color: #FF6644;
        margin-right: 12px;
        font-weight: 400;
      }
      .jd-info {
        font-size: 14px;
        color: #606060;
        display: flex;
        span {
          display: flex;
          align-items: center;
          &::after {
            content: "";
            display: block;
            width: 1px;
            height: 12px;
            margin: 0 6px;
            background-color: #606060;
          }
          &:last-child::after {
            content: "";
            display: none;
          }
        }
      }
    }
    .company {
      width: 251px;
      margin-left: 64px;
      .company-name {
        font-size: 14px;
        color: #404040;
        font-weight: 400;
      }
      .company-info {
        font-size: 14px;
        color: #9C9C9C;
        span {
          display: flex;
          &::after {
            content: "|";
            display: block;
            width: 10px;
            text-align: center;
          }
          &:last-child::after {
            content: "";
            width: 0;
          }
        }
      }
    }
    .company-picture {
      margin-left: 24px;
      width: 44px;
      height: 44px;
      border-radius: 4px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #F9F9F9;
      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .tag {
    display: flex;
    border-top: 1px dashed #EDEDED;
    .tag-content-main {

      height: 52px;
      overflow: hidden;
    }
    .tag-content {
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
    }
    .tag-more {
      flex: none;
    }
    .tag-menu {
      height: 24px;
      border-radius: 12px;
      padding: 0 12px;
      line-height: 24px;
      font-size: 14px;
      color: #4183FF;
      background: #F7F9FF;
      margin-right: 12px;
      margin-top: 14px;
      .iconfont {
        font-size: 18px;
      }
    }
  }
  .jd-tag {
    width: 70px;
    height: 18px;
    background: rgba(65, 131, 255, .05);
    color: rgba(65, 131, 255, 1);
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    position: absolute;
    top: 6px;
    left: -20px;
    z-index: 5;
    transform-origin: 50% 50%;
    transform: rotate(-45deg);
  }
}
</style>
